import {
  type MaintenanceTemplateKind,
  type MaintenanceTemplateListQuery,
} from '@gb-ticket/shared-types';

import { toSearchParams } from '@/lib/format';
import { MAINTENANCE_TEMPLATES_PATH } from '@/products/maintenance/maintenance-paths';

const EMPTY: MaintenanceTemplateListQuery = {
  page: 1,
  pageSize: 25,
  sortBy: 'name',
  sortOrder: 'asc',
};

export function maintenanceTemplateListPath(
  patch: Partial<MaintenanceTemplateListQuery> = {},
): string {
  const merged = { ...EMPTY, ...patch };
  return `${MAINTENANCE_TEMPLATES_PATH}${toSearchParams({
    page: merged.page,
    pageSize: merged.pageSize,
    sortBy: merged.sortBy,
    sortOrder: merged.sortOrder,
    q: merged.q,
    isActive: merged.isActive === undefined ? undefined : String(merged.isActive),
    kind: merged.kind,
  })}`;
}

export function maintenanceTemplateListQueryFromSearch(
  search: string,
): Partial<MaintenanceTemplateListQuery> | null {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  if ([...params.keys()].length === 0) {
    return null;
  }
  return {
    page: params.get('page') ? Number(params.get('page')) || 1 : 1,
    pageSize: params.get('pageSize') ? Number(params.get('pageSize')) || 25 : 25,
    sortBy: (params.get('sortBy') as MaintenanceTemplateListQuery['sortBy']) || 'name',
    sortOrder: params.get('sortOrder') === 'desc' ? 'desc' : 'asc',
    q: params.get('q') ?? undefined,
    isActive:
      params.get('isActive') === 'true'
        ? true
        : params.get('isActive') === 'false'
          ? false
          : undefined,
    kind: parseTemplateKind(params.get('kind')),
  };
}

function parseTemplateKind(value: string | null): MaintenanceTemplateKind | undefined {
  if (
    value === 'structured' ||
    value === 'pdf_overlay' ||
    value === 'pdf_ink' ||
    value === 'pdf_acroform'
  ) {
    return value;
  }
  return undefined;
}
